import { render, staticRenderFns } from "./RecargoCreate.vue?vue&type=template&id=96d5a7ce&scoped=true&"
import script from "./RecargoCreate.vue?vue&type=script&lang=js&"
export * from "./RecargoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5a7ce",
  null
  
)

export default component.exports